(function() {
  'use strict';

  const SERIES_DATA = {
    all: {
      code: '',
      pill: 'CATALOG',
      count: '25',
      titleJa: '暮らしの道具、全25点。',
      titleEn: 'All Handcrafted Objects',
      sub: 'Raw Texture, Timeless Soul.',
      descJa: '国内工房にて職人が国産焼杉と黒皮アイアン配管を組み上げ、丁寧に仕立てた焼杉インテリア・アイアン配管家具・インダストリアル雑貨の暮らしの道具。',
      descEn: 'Domestic atelier craft. 25 objects made with charred cedar, raw iron pipes, and brass fittings.',
      material: '天然焼杉・黒皮ガス管・水栓パーツ'
    },
    C: {
      code: 'C',
      pill: 'C SERIES',
      count: '4',
      titleJa: 'C · コーヒーと台所',
      titleEn: 'C Series: Coffee & Kitchen',
      sub: 'Coffee & Kitchen Objects',
      descJa: 'ドリッパーやポットの自重を受け止める台座、真鍮と黒皮配管で仕立てた珈琲スタンドやキッチンラック。',
      descEn: 'Pour-over dripper and kettle stands crafted from charred cedar, raw gas pipes, and brass fittings.',
      material: '天然焼杉・工業配管・真鍮'
    },
    D: {
      code: 'D',
      pill: 'D SERIES',
      count: '1',
      titleJa: 'D · 花と小さな景色',
      titleEn: 'D Series: Flower & Tabletop Scenery',
      sub: 'Tabletop Green & Scenery',
      descJa: '水道蛇口の鋳鉄バルブをベースに、ガラス試験管を組み合わせた卓上一輪挿し。水替えも容易です。',
      descEn: 'A tabletop single-stem vase combining a cast-iron faucet base with a removable glass test tube.',
      material: '天然焼杉・真鍮水栓・試験管'
    },
    R: {
      code: 'R',
      pill: 'R SERIES',
      count: '11',
      titleJa: 'R · 収納とディスプレイ',
      titleEn: 'R Series: Storage & Display',
      sub: 'Storage, Books & Display',
      descJa: '文庫本、LPレコード、小物の定位置に。約1kg〜1.5kgの自重で引き抜き時も倒れにくい収納ラック。',
      descEn: 'Shelves, book and record stands built with ~1kg–1.5kg self-weight to prevent tipping when pulled.',
      material: '天然焼杉・黒皮ガス管・鉄角棒'
    },
    S: {
      code: 'S',
      pill: 'S SERIES',
      count: '1',
      titleJa: 'S · スマートフォンの居場所',
      titleEn: 'S Series: Smartphone Stand',
      sub: 'Dedicated Place for Mobile',
      descJa: 'キッチンでレシピを見るときや卓上作業に。充電ケーブルを通したまま縦横に置ける鋳鉄配管スタンド。',
      descEn: 'A low-center-of-gravity cast iron pipe phone stand that supports vertical and horizontal use while charging.',
      material: '天然焼杉・配管パーツ'
    },
    W: {
      code: 'W',
      pill: 'W SERIES',
      count: '6',
      titleJa: 'W · 壁を楽しむ道具',
      titleEn: 'W Series: Wall Display & Hooks',
      sub: 'Vertical Living & Wall Craft',
      descJa: '鍵、帽子、コート、道具の壁面収納。石膏ボードや木壁に取り付ける配管フックと飾り棚。',
      descEn: 'Wall racks and pipe hooks for keys, coats, and everyday tools. Mounts securely to drywall or wood walls.',
      material: '天然焼杉・配管フック'
    },
    M: {
      code: 'M',
      pill: 'M SERIES',
      count: '2',
      titleJa: 'M · ミニマルな道具',
      titleEn: 'M Series: Minimal & Magnets',
      sub: 'Compact Living & Everyday Accents',
      descJa: '日常の金属面に無骨な遊び心を。焼杉と配管パーツに強力磁石を組み合わせたミニマルな生活道具。',
      descEn: 'Compact magnetic hooks and tools crafted from charred cedar, iron faucet fittings, and rare-earth magnets.',
      material: '天然焼杉・鋳鉄パーツ・強力磁石'
    }
  };

  function getQuerySeries() {
    const params = new URLSearchParams(window.location.search);
    const series = params.get('series') || params.get('filter.p.m.custom.series');
    if (series) {
      const upper = series.toUpperCase();
      if (['C', 'D', 'M', 'R', 'S', 'W'].includes(upper)) return upper;
    }
    return null;
  }

  function getProductSkuOrPrefix(card) {
    // Try to find SKU or prefix from card links, titles or data attributes
    const link = card.querySelector('a.card__heading, a[href*="/products/"]');
    if (!link) return '';
    const href = link.getAttribute('href') || '';
    const text = (card.textContent || '').trim();

    // Match handle pattern: /products/c-01-..., /products/m-01-..., /products/r-02-...
    const handleMatch = href.match(/\/products\/([a-z])-([0-9]+)/i);
    if (handleMatch) {
      return handleMatch[1].toUpperCase();
    }

    // Match text prefix: C-01, D-01, M-01, R-02, S-01, W-01
    const textMatch = text.match(/\b([CDMRWS])-[0-9]{2}\b/i);
    if (textMatch) {
      return textMatch[1].toUpperCase();
    }

    return '';
  }

  function syncDynamicCountsFromGrid() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const items = grid.querySelectorAll('.grid__item');
    if (!items.length) return;

    const counts = { all: items.length, C: 0, D: 0, M: 0, R: 0, S: 0, W: 0 };
    items.forEach(item => {
      const s = getProductSkuOrPrefix(item);
      if (counts[s] !== undefined) counts[s]++;
    });

    for (const key in counts) {
      if (SERIES_DATA[key]) {
        SERIES_DATA[key].count = String(counts[key]);
        if (key === 'all') {
          SERIES_DATA.all.titleJa = `暮らしの道具、全${counts.all}点。`;
          SERIES_DATA.all.descEn = `Domestic atelier craft. ${counts.all} objects made with charred cedar, raw gas pipes, and brass fittings.`;
        }
      }
    }

    document.querySelectorAll('.kr-series-tab').forEach(tab => {
      const tabKey = tab.getAttribute('data-series');
      const countEl = tab.querySelector('.kr-series-tab-count');
      if (countEl && counts[tabKey] !== undefined) {
        countEl.textContent = counts[tabKey];
      }
    });
  }

  function initSeriesFilter() {
    const header = document.getElementById('KurashiSeriesHeader');
    if (!header) return;

    const tabs = header.querySelectorAll('.kr-series-tab');
    const isEn = document.documentElement.lang === 'en';
    const serverSeries = header.getAttribute('data-current-series') || '';

    syncDynamicCountsFromGrid();

    function applyFilter(seriesKey, updateUrl) {
      const key = (seriesKey && seriesKey !== 'all') ? seriesKey.toUpperCase() : 'all';
      const data = SERIES_DATA[key] || SERIES_DATA.all;

      // Update Tabs active state
      tabs.forEach(tab => {
        const tabKey = tab.getAttribute('data-series');
        if ((key === 'all' && tabKey === 'all') || (tabKey && tabKey.toUpperCase() === key)) {
          tab.classList.add('is-active');
        } else {
          tab.classList.remove('is-active');
        }
      });

      // Update Hero Content
      const pill = document.getElementById('krSeriesPill');
      const countBadge = document.getElementById('krSeriesCountBadge');
      const title = document.getElementById('krSeriesTitle');
      const subtitle = document.getElementById('krSeriesSubtitle');
      const desc = document.getElementById('krSeriesDesc');
      const specMaterial = document.getElementById('krSpecMaterial');

      if (pill) pill.textContent = data.pill;
      if (countBadge) countBadge.textContent = data.count + (isEn ? ' Objects' : ' 作品');
      if (title) title.textContent = isEn ? data.titleEn : data.titleJa;
      if (subtitle) subtitle.textContent = data.sub;
      if (desc) desc.innerHTML = `<p>${isEn ? data.descEn : data.descJa}</p>`;
      if (specMaterial) {
        const matClean = (data.material || '').replace(/・/g, ' · ');
        specMaterial.innerHTML = `<span class="kr-atelier-dot"></span><span class="kr-atelier-text">${matClean}</span>`;
      }

      // Filter product grid items (if grid is present on page)
      const grid = document.getElementById('product-grid');
      if (grid) {
        const items = grid.querySelectorAll('.grid__item');
        let visibleCount = 0;

        items.forEach(item => {
          const itemSeries = getProductSkuOrPrefix(item);
          if (key === 'all' || itemSeries === key) {
            item.style.display = '';
            item.classList.add('scroll-trigger--cancel');
            item.style.opacity = '1';
            item.style.transform = 'none';
            item.style.visibility = 'visible';
            visibleCount++;
          } else {
            item.style.display = 'none';
          }
        });

        // Update count badge with actual visible if filtered
        if (countBadge && key !== 'all') {
          countBadge.textContent = visibleCount + (isEn ? ' Objects' : ' 作品');
        }
      }

      // Update browser URL query without reload if requested
      if (updateUrl) {
        const url = new URL(window.location.href);
        if (key === 'all') {
          url.searchParams.delete('series');
          url.searchParams.delete('filter.p.m.custom.series');
        } else {
          url.searchParams.set('series', key);
          url.searchParams.delete('filter.p.m.custom.series');
        }
        window.history.pushState({ series: key }, '', url.toString());
      }
    }

    // Determine initial series from URL or server-rendered handle
    const initialQuerySeries = getQuerySeries();
    if (initialQuerySeries) {
      applyFilter(initialQuerySeries, false);
    } else if (serverSeries) {
      applyFilter(serverSeries, false);
    }

    // Tab click delegation
    tabs.forEach(tab => {
      tab.addEventListener('click', function(e) {
        const targetSeries = this.getAttribute('data-series');
        const isCollectionsAll = window.location.pathname.includes('/collections/all') || window.location.pathname.endsWith('/collections');

        // If we are on /collections/all, smoothly filter without full page reload
        if (isCollectionsAll) {
          e.preventDefault();
          applyFilter(targetSeries, true);
        }
      });
    });

    // Handle back/forward navigation
    window.addEventListener('popstate', function() {
      const qSeries = getQuerySeries();
      applyFilter(qSeries || serverSeries || 'all', false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSeriesFilter);
  } else {
    initSeriesFilter();
  }
})();
